<template>

    <div class="card-panel hoverable">
        <h4 class="card-title">Past Month Scores</h4>
        <div class="divider"></div>
        <div class="row">
            <div class="col s12 m12 l12">
                <span v-if="loadByUserId === 0 && isAdmin">Select a member to display.</span>
                <span v-else>
                     <span v-if="loading">Loading ...</span>
                    <div v-if="!hasData && !loading && !isAdmin">
                        <h6>You have not enough scores data.</h6>
                        <a :href="createScoreUrl"
                           class="btn waves-light" style="margin-top: 15px">Create a Score</a>
                    </div>

                    <div v-if="!hasData && !loading && isAdmin">
                        <h6>No available scores data for this member.</h6>
                    </div>
                </span>

                <canvas id="scoreChart" v-show="!loading && hasData"></canvas>
                <div id="chartjs-tooltip"></div>
            </div>
        </div>
    </div>

</template>

<script>
  import axios from 'axios'

  export default {
    name : 'PastMonthsSummary',
    props: {
      dataUrl: String,
      createScoreUrl: String,
      haltInitiate: Boolean,
      isAdmin: Boolean,
      selectedUser: Object
    },

    data() {
      return {
        loading: true,
        hasData : false,
        data: [],
        metadata: [],
        labels: [],
        loadedChart: null,
        loadByUserId: 0
      }
    },

    watch: {
      selectedUser () {
        // from dashboard component
        this.loadByUserId = this.selectedUser.id;
        this.loadData();
      }
    },

    mounted() {
      // window.addEventListener('reload_past_months_summary', (payload) => {
      //   this.loadByUserId = payload.detail.user_id;
      //   this.loadData();
      // });

      if (this.haltInitiate) {
        return;
      }

      this.loadData();
    },

    methods: {
      deselectUserId () {
        this.loadByUserId = 0;
        this.hasData = false;
      },

      loadData() {

        this.loading = true;

        let data = '';

        if (this.loadByUserId > 0) {
          data += '&user_id=' + this.loadByUserId;
        }

        axios.get(this.dataUrl + data)
          .then(response => {

            this.loading = false;
            if(response.data.results && response.data.results.labels.length > 0) {

              this.data = response.data.results.datasets;
              this.metadata = response.data.results.metadata;
              this.labels = response.data.results.labels;
              this.initChart();
              this.hasData = true;

            } else {
              this.hasData = false;
            }

          })
          .catch(err => {

            this.loading = false;
            M.toast({html: 'Error, loading past months' + err, classes: 'red accent-2'});

          });

      },

      initChart() {
        var ctx = document.getElementById("scoreChart");
        ctx.height = 350;

        if (this.loadedChart) {
          this.loadedChart.destroy();
        }

        const totalizer = {
          id: 'totalizer',

          beforeUpdate: chart => {
            let totals = {}
            let utmost = 0

            chart.data.datasets.forEach((dataset, datasetIndex) => {
              if (chart.isDatasetVisible(datasetIndex)) {
                utmost = datasetIndex
                dataset.data.forEach((value, index) => {
                  totals[index] = (totals[index] || 0) + value
                })
              }
            })

            chart.$totalizer = {
              totals: totals,
              utmost: utmost
            }
          }
        }

        this.loadedChart = new Chart(ctx, {
          tooltipCaretSize: 0,
          plugins: [totalizer],
          type: 'bar',
          data: {
            labels: this.labels,
            // create 12 datasets, since we have 12 items
            // data[0] = labels[0] (data for first bar - 'Standing costs') | data[1] = labels[1] (data for second bar - 'Running costs')
            // put 0, if there is no data for the particular bar
            datasets: this.data,
            metadata: this.metadata
          },


          options: {
            layout: {
              padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
              }
            },

            plugins: {
              datalabels: {
                align: 'end',
                anchor: 'end',
                formatter: (value, ctx) => {
                  return ctx.chart.$totalizer.totals[ctx.dataIndex]
                },
                display: function(ctx) {
                  return ctx.datasetIndex === ctx.chart.$totalizer.utmost
                },
              }
            },

            responsive: true,
            legend: {
              position: 'bottom',
              labels: {
                boxWidth: 10,
                fontSize: 11,
                padding: 5
              }
            },
            scales: {
              xAxes: [{
                stacked: true, // this should be set to make the bars stacked
                ticks: {
                  fontSize: 10,
                  lineHeight: 1,
                  maxRotation: 0, // angle in degrees
                }
              }],
              yAxes: [{
                stacked: true, // this also..
                ticks: {
                  max: 100
                }
              }]
            },
            tooltips: {
              // enabled: false,
              // callbacks:{
              //   label: function(tooltipItem, data) {
              //     let comment = data.metadata[tooltipItem.datasetIndex][tooltipItem.index];
              //
              //     if (comment.length > 0) {
              //       //comment = this.chunkString(comment, 40);
              //       let result = [];
              //       let strArr = comment.split("\n");
              //       let index = 0;
              //       strArr.forEach((data) => {
              //
              //         if (data.length <= 40) {
              //           result.push(data);
              //         } else {
              //           let newStr = data;
              //           let newLength = 40;
              //
              //           while (newStr.length > 0) {
              //             if (newStr.charAt(newLength) !== ' ' && newLength < newStr.length) {
              //               newLength++;
              //             } else {
              //               result.push(newStr.substr(0, newLength));
              //               newStr = newStr.substr(newLength);
              //               newLength = 40; // reset
              //             }
              //           }
              //         }
              //         index++;
              //       });
              //
              //       comment = result;
              //     } else {
              //       comment = "Nil";
              //     }
              //
              //     let datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
              //     //This will be the tooltip.body
              //     return datasetLabel + '|SPLIT| ' + tooltipItem.yLabel + '|SPLIT|' + comment.join('|SPLIT|');
              //
              //   },
              // },
              // custom: function (tooltip) {
              //   var tooltipEl = $('#chartjs-tooltip');
              //
              //   if (!tooltip) {
              //     tooltipEl.css({
              //       opacity: 0
              //     });
              //     return;
              //   }
              //
              //   tooltipEl.removeClass('above below');
              //   tooltipEl.addClass(tooltip.yAlign);
              //
              //   // split out the label and value and make your own tooltip here
              //   console.log(tooltip.body);
              //   var parts = tooltip.body[0].lines[0].split("|SPLIT|");
              //   var innerHtml = '<span>' + parts[0].trim() + '</span> : <span><b>' + parts[1].trim() + '</b> '+parts[2].trim()+'</span>';
              //   console.log(innerHtml);
              //   tooltipEl.html(innerHtml);
              //
              //   var position = this._chart.canvas.getBoundingClientRect();
              //
              //   tooltipEl.css({
              //     opacity: 1,
              //     position: 'absolute',
              //     left: position.left + window.pageXOffset + tooltip.caretX + 'px',
              //     top: position.top + window.pageYOffset + tooltip.caretY + 'px',
              //     fontFamily: tooltip.fontFamily,
              //     fontSize: tooltip.fontSize,
              //     fontStyle: tooltip.fontStyle,
              //   });
              //
              //   console.log(tooltip.dataPoints[0]);
              //
              // },
              callbacks: {
                afterFooter: (tooltipItem, data) => {
                  //let label = data.datasets[tooltipItem.datasetIndex].label || '';

                  let comment = data.metadata[tooltipItem[0].datasetIndex][tooltipItem[0].index];

                  if (comment.length > 0) {
                    return this.chunkString(comment, 40);
                  } else {
                    return "Nil";
                  }
                }
              }
            },
          }
        });
      },

      chunkString (str, length) {
        let result = [];
        let strArr = str.split("\n");
        let index = 0;
        strArr.forEach((data) => {

          if (data.length <= length) {
            result.push(data);
          } else {
            let newStr = data;
            let newLength = length;

            while (newStr.length > 0) {
              if (newStr.charAt(newLength) !== ' ' && newLength < newStr.length) {
                newLength++;
              } else {
                result.push(newStr.substr(0, newLength));
                newStr = newStr.substr(newLength);
                newLength = length; // reset
              }
            }
          }
          index++;
        });

        return result;
      }
    }
  }
</script>


<style lang="scss" scoped>
    #chartjs-tooltip {
        opacity: 0;
        position: absolute;
        background: rgba(0, 0, 0, .7);
        color: white;
        padding: 3px;
        border-radius: 3px;
        -webkit-transition: all .1s ease;
        transition: all .1s ease;
        pointer-events: none;
        -webkit-transform: translate(-50%, 0);
        transform: translate(-50%, 0);
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/scores/PastMonthsSummary.vue